/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTumorBoards } from 'app/entities/tumor-board/tumor-board.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './tumor-board-occurrence.reducer';

export const TumorBoardOccurrenceUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tumorBoards = useAppSelector(state => state.tumorBoard.entities);
  const tumorBoardOccurrenceEntity = useAppSelector(state => state.tumorBoardOccurrence.entity);
  const loading = useAppSelector(state => state.tumorBoardOccurrence.loading);
  const updating = useAppSelector(state => state.tumorBoardOccurrence.updating);
  const updateSuccess = useAppSelector(state => state.tumorBoardOccurrence.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/tumor-board-occurrence${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTumorBoards({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.scheduleStartTime !== undefined && typeof values.scheduleStartTime !== 'number') {
      values.scheduleStartTime = Number(values.scheduleStartTime);
    }
    if (values.scheduleEndTime !== undefined && typeof values.scheduleEndTime !== 'number') {
      values.scheduleEndTime = Number(values.scheduleEndTime);
    }
    if (values.scheduleDate !== undefined && typeof values.scheduleDate !== 'number') {
      values.scheduleDate = Number(values.scheduleDate);
    }
    if (values.startedAt !== undefined && typeof values.startedAt !== 'number') {
      values.startedAt = Number(values.startedAt);
    }
    if (values.completedAt !== undefined && typeof values.completedAt !== 'number') {
      values.completedAt = Number(values.completedAt);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tumorBoardOccurrenceEntity,
      ...values,
      board: tumorBoards.find(it => it.id.toString() === values.board?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          createdByType: 'ACCOUNTANT',
          ...tumorBoardOccurrenceEntity,
          board: tumorBoardOccurrenceEntity?.board?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tumorBoardOccurrence.home.createOrEditLabel" data-cy="TumorBoardOccurrenceCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.home.createOrEditLabel">
              Create or edit a TumorBoardOccurrence
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tumor-board-occurrence-id"
                  label={translate('tinyMedicRestApp.tumorBoardOccurrence.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.eventName')}
                id="tumor-board-occurrence-eventName"
                name="eventName"
                data-cy="eventName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="eventNameLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.eventName" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.eventDescription')}
                id="tumor-board-occurrence-eventDescription"
                name="eventDescription"
                data-cy="eventDescription"
                type="text"
              />
              <UncontrolledTooltip target="eventDescriptionLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.eventDescription" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.scheduleStartTime')}
                id="tumor-board-occurrence-scheduleStartTime"
                name="scheduleStartTime"
                data-cy="scheduleStartTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="scheduleStartTimeLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.scheduleStartTime" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.scheduleEndTime')}
                id="tumor-board-occurrence-scheduleEndTime"
                name="scheduleEndTime"
                data-cy="scheduleEndTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="scheduleEndTimeLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.scheduleEndTime" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.scheduleDate')}
                id="tumor-board-occurrence-scheduleDate"
                name="scheduleDate"
                data-cy="scheduleDate"
                type="text"
              />
              <UncontrolledTooltip target="scheduleDateLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.scheduleDate" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.outcomeSummary')}
                id="tumor-board-occurrence-outcomeSummary"
                name="outcomeSummary"
                data-cy="outcomeSummary"
                type="text"
              />
              <UncontrolledTooltip target="outcomeSummaryLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.outcomeSummary" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.startedAt')}
                id="tumor-board-occurrence-startedAt"
                name="startedAt"
                data-cy="startedAt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="startedAtLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.startedAt" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.completedAt')}
                id="tumor-board-occurrence-completedAt"
                name="completedAt"
                data-cy="completedAt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="completedAtLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.completedAt" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.createdById')}
                id="tumor-board-occurrence-createdById"
                name="createdById"
                data-cy="createdById"
                type="text"
              />
              <UncontrolledTooltip target="createdByIdLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.createdById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.createdByType')}
                id="tumor-board-occurrence-createdByType"
                name="createdByType"
                data-cy="createdByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.active')}
                id="tumor-board-occurrence-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.cursor')}
                id="tumor-board-occurrence-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.lastUpdated')}
                id="tumor-board-occurrence-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.microSec')}
                id="tumor-board-occurrence-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.timestampEntry')}
                id="tumor-board-occurrence-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrence.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tumor-board-occurrence-board"
                name="board"
                data-cy="board"
                label={translate('tinyMedicRestApp.tumorBoardOccurrence.board')}
                type="select"
              >
                <option value="" key="0" />
                {tumorBoards
                  ? tumorBoards.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tumor-board-occurrence" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TumorBoardOccurrenceUpdate;
